import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=614ddd8f&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "614ddd8f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('614ddd8f')) {
      api.createRecord('614ddd8f', component.options)
    } else {
      api.reload('614ddd8f', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=614ddd8f&scoped=true&", function () {
      api.rerender('614ddd8f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4h3u5z1Z3gd7G/JS/comp/Accordion.vue"
export default component.exports